import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SessionStorageService} from './session-storage.service';
import {BaseApiService} from './base-api.service';
import {Coleta} from '../models/coleta';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ColetaService extends BaseApiService{

  readonly INICIO_ENDPOINT = '/perfil/produto'
  readonly RESPONDIDOS_ENDPOINT = '/respondidos'

  constructor(private httpClient: HttpClient, private localStorageService: SessionStorageService) {
    super('whitelabel/grupos', localStorageService);
  }

  get(): Promise<Coleta[]> {
    const {productId, origemComercialId, consultaExternaConfig} = this.localStorageService.getEnvConfig();
    let url: string;

    if (productId && origemComercialId) {
      url = `${this.baseUrl}${this.INICIO_ENDPOINT}/${productId}?origemComercialId=${origemComercialId}
      ${consultaExternaConfig?.fluxoId ? `&fluxoId=${consultaExternaConfig?.fluxoId}` : ''}`;
    } else {
      url = `${this.baseUrl}${this.INICIO_ENDPOINT}/${productId}`;
    }

    return this.httpClient
      .get<any>(url)
      .pipe(map(item => item.data as Coleta[]))
      .toPromise();
  }

  getRespondidos(idPerfil: number, processo: string, configuracaoAtributo: string[]): Promise<Coleta[]> {

    const params: HttpParams = new HttpParams()
    .set("idPerfil", idPerfil)
    .set("processo", processo)
    .set("configuracaoAtributo", configuracaoAtributo.join(","));
    
    let url: string;

    url = `${this.baseUrl}${this.RESPONDIDOS_ENDPOINT}`

    return this.httpClient
      .get<any>(url, {params: params})
      .pipe(map(item => item.data as Coleta[]))
      .toPromise();
  }
}
